module.exports = __webpack_public_path__ + "static/media/netfilter.7d1038d3.png";